import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserNotLoggedInError from '../Errors/UserNotLoggedInUserError.js'
import UserRepositoriesFactory from '../Repositories/factory.js'
import UserServicesFactory from '../Services/factory.js'

export class RequestTakeoutDataUserUseCase extends UseCase {
  #getCurrentUserService
  #userRepository

  constructor({getCurrentUserService, userRepository}) {
    super()
    this.#getCurrentUserService = getCurrentUserService
    this.#userRepository = userRepository
  }

  @tracer({metric: 'RequestTakeoutDataUserUseCase#execute'})
  @AsyncInlineError()
  async execute() {
    const userEntity = await this.#getCurrentUserService.execute()

    if (!userEntity) {
      throw new UserNotLoggedInError({message: 'User must be logged in to request takeout data'})
    }

    const [repositoryError] = await this.#userRepository.requestTakeoutData({userEntity})

    if (repositoryError) {
      return Promise.reject(repositoryError)
    }
  }

  static create({config}) {
    const getCurrentUserService = UserServicesFactory.getCurrentUserService({
      config
    })
    const userRepository = UserRepositoriesFactory.httpUserRepository({config})
    return new RequestTakeoutDataUserUseCase({getCurrentUserService, userRepository})
  }
}

export const factory = RequestTakeoutDataUserUseCase.create
